import metadata from './meta/metadata';
import form from './sections/form';

const translations = {
    form,
};

export const meta = {
    ...metadata,
};

export default translations;